import React from 'react';
import moment from 'moment';

type Props = {
  date: string | Date | moment.Moment | null;
};

export const DetailedDateTime = ({ date }: Props) =>
  date ? <span>{moment(date).format('YYYY年MM月DD日 HH:mm')}</span> : null;
